const MemoIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12 21C16.9706 21 21 16.9706 21 12C21 7.02944 16.9706 3 12 3C7.02944 3 3 7.02944 3 12V17C3 19.2091 4.79086 21 7 21H12Z"
        fill="#8646F2"
      />
      <circle cx="12" cy="12" r="1" fill="white" />
      <circle cx="16" cy="12" r="1" fill="white" />
      <circle cx="8" cy="12" r="1" fill="white" />
    </svg>
  );
};

export default MemoIcon;
